import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  variant?: 'primary' | 'secondary';
  href?: string;
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function CTAButton({
  text,
  variant = 'primary',
  href = '#',
  className = '',
  fullWidth = false,
  showIcon = true
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-bold transition-all duration-300 text-lg md:text-xl px-8 py-4 rounded-full tracking-wide cursor-pointer';
  const variants = {
    primary: 'bg-gradient-to-r from-[#9B2C5E] to-[#E05275] text-white shadow-lg shadow-rose-900/20 border border-transparent hover:shadow-xl hover:shadow-rose-900/30',
    secondary: 'bg-transparent border-2 border-[#9B2C5E] text-[#9B2C5E] hover:bg-[#9B2C5E] hover:text-white'
  };
  const handleClick = (e: React.MouseEvent) => {
    // Fire Meta Pixel AddToCart event on every CTA click
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
    if (href === '#') {
      e.preventDefault();
      const target = document.getElementById('pricing-cta');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <motion.a href={href} onClick={handleClick} className={`${baseClasses} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} data-id="element-221">
      {text}
      {showIcon && <ArrowRight className="ml-2 w-5 h-5" data-id="element-222" />}
    </motion.a>;
}